const scrollBehavior = (to, from, savedPosition) => {
  // 暂不处理
}

export default scrollBehavior



// WEBPACK FOOTER //
// ./src/router/scrollBehavior.js